// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3XHZf","buttons":"PendingPaymentAlert_buttons__2cLFr"};